export { SocoCoreModule } from '@app/soco/core/core_module';

// DSS Documentation on ApiResult - http://tiny.sc/cgapiresult
// DSS Documentation on Validation - http://tiny.sc/cgvalidation
export { ApiResult } from '@app/soco/core/api-result';
// DSS Documentation on Validation - http://tiny.sc/cgvalidation
export { ModelError } from '@app/soco/core/model-error';
